import {useState} from 'react';
import {OrderData} from '../suspendedConfirmation';
import * as cardCss from './card/card.css';
import EventHeader from './EventHeader';
import EventDetails from './EventDetails';
import OrderSummary from './OrderSummary';
import TicketSelection from './TicketSelection';
import ActionButtons from './ActionButtons';
import {useTicketValidation} from './useTicketValidation';

function DecisionScreen({
    orderData,
    onResponse
}:{
    orderData: OrderData;
    onResponse?: (res: any) => void;
}){
    const [selectedTickets, setSelectedTickets] = useState<Array<any>>(orderData?.ticketsQr || []);
    const {handleConfirmation} = useTicketValidation();

    const handleButtonClick = async (token: string | undefined) => {
        await handleConfirmation(token, selectedTickets, onResponse);
    };
 
    if(!orderData) return <></>;
    
    return (
        <cardCss.card>
            <EventHeader 
                nameFirst={orderData.nameFirst} 
                nameLast={orderData.nameLast} 
            />
            
            <EventDetails
                nameFirst={orderData.nameFirst}
                nameLast={orderData.nameLast}
                eventTitle={orderData.eventTitle}
                location={orderData.location}
                timeStart={orderData.timeStart}
                timeEnd={orderData.timeEnd}
                emailContent={orderData.emailContent}
            />

            <OrderSummary
                nameFirst={orderData.nameFirst}
                nameLast={orderData.nameLast}
                creditCard={orderData.creditCard}
                ticketsAmount={orderData.ticketsAmount}
                ticketTitle={orderData.ticketTitle}
                oid={orderData.oid}
            />

            <TicketSelection
                ticketsQr={orderData.ticketsQr || []}
                onTicketsChange={setSelectedTickets}
            />

            <ActionButtons
                confirmUrl={orderData.confirmUrl}
                maybeUrl={orderData.maybeUrl}
                cancelUrl={orderData.cancelUrl}
                onButtonClick={handleButtonClick}
                selectedTickets={selectedTickets.length}
                ticketsAmount={orderData.ticketsAmount}
            />
        </cardCss.card>
    );
}

export default DecisionScreen;
